import { YEAR_END_PROCESS_REQUEST, YEAR_END_PROCESS_FAILURE, YEAR_END_PROCESS_SUCCESS, SET_PROFIT_LOSS_AMOUNT, SAVE_YEAR_END_PROCESS } from "../types";

const initialState = {
  profitLoss: {},
  jvs: [],
  loading: false,
  error: null,
};

const yearEndProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case YEAR_END_PROCESS_REQUEST: {
      return {
        ...state,
        profitLoss: {},
        loading: true,
        error: null
      };
    }
    case SET_PROFIT_LOSS_AMOUNT: {
      return {
        ...state,
        profitLoss: action.payload || {},
        loading: false,
        error: null
      };
    }
    case SAVE_YEAR_END_PROCESS: {
      return {
        ...state,
        profitLoss: action.payload?.profitLoss || {},
        jvs: action.payload?.jvs || [],
        loading: false,
        error: null
      };
    }
    case YEAR_END_PROCESS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case YEAR_END_PROCESS_FAILURE: {
      return {
        ...state,
        profitLoss: 0,
        jvs: [],
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default yearEndProcessReducer;
